var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6668 9.66699H13.0002C12.5581 9.66699 12.1342 9.84259 11.8217 10.1551C11.5091 10.4677 11.3335 10.8916 11.3335 11.3337V24.667C11.3335 25.109 11.5091 25.5329 11.8217 25.8455C12.1342 26.1581 12.5581 26.3337 13.0002 26.3337H23.0002C23.4422 26.3337 23.8661 26.1581 24.1787 25.8455C24.4912 25.5329 24.6668 25.109 24.6668 24.667V14.667L19.6668 9.66699ZM21.1668 24.667H19.6668L18.0002 21.8337L16.3335 24.667H14.8335L17.2502 20.917L14.8335 17.167H16.3335L18.0002 20.0003L19.6668 17.167H21.1668L18.7502 20.917L21.1668 24.667ZM18.8335 15.5003V10.917L23.4168 15.5003H18.8335Z",
    fill: "#28519E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 3.5,
    stroke: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.bdaabafd574b7fab92eb6982e4cac868.svg";
export { ForwardRef as ReactComponent };